import { Navigate, Outlet, Route, useLocation } from "react-router-dom";

import RootLayout from "./app/layout";
import { NotFoundPage, page, PageBoundary, ScrollManager } from "./next/page";

function SiteShell() {
  const { pathname } = useLocation();
  return (
    <RootLayout>
      <ScrollManager />
      <PageBoundary key={pathname}>
        <Outlet />
      </PageBoundary>
    </RootLayout>
  );
}

// Permanent and temporary redirects from website/next.config.ts.
const REDIRECTS: Array<[string, string]> = [
  ["/about", "/about-us"],
  ["/help", "/help-center"],
  ["/contact", "/help-center"],
  ["/contact-us", "/help-center"],
  ["/privacy", "/privacy-policy"],
  ["/terms", "/terms-of-use"],
  ["/crypto-exchange", "/crypto"],
  ["/gift-card", "/gift-cards"],
  ["/rates/*", "/download"],
];

// Every page of the Jamestown website (website/src/app), mounted in this app.
export const siteRoutes = (
  <Route element={<SiteShell />}>
    {REDIRECTS.map(([from, to]) => (
      <Route key={from} path={from} element={<Navigate to={to} replace />} />
    ))}

    <Route index element={page(() => import("./app/page"))} />
    <Route path="/about-us" element={page(() => import("./app/about-us/page"))} />
    <Route path="/airtime" element={page(() => import("./app/airtime/page"))} />
    <Route path="/crypto" element={page(() => import("./app/crypto/page"))} />
    <Route path="/crypto/bitcoin" element={page(() => import("./app/crypto/bitcoin/page"))} />
    <Route path="/crypto/usdc" element={page(() => import("./app/crypto/usdc/page"))} />
    <Route path="/crypto/usdt" element={page(() => import("./app/crypto/usdt/page"))} />
    <Route path="/data" element={page(() => import("./app/data/page"))} />
    <Route path="/dictionary" element={page(() => import("./app/dictionary/page"))} />
    <Route path="/dictionary/:slug" element={page(() => import("./app/dictionary/[slug]/page"), { async: true })} />
    <Route path="/download" element={page(() => import("./app/download/page"))} />
    <Route path="/explorer" element={page(() => import("./app/explorer/page"))} />
    <Route path="/explorer/lab" element={page(() => import("./app/explorer/lab/page"))} />
    <Route path="/explorer/address/:address" element={page(() => import("./app/explorer/address/[address]/page"), { async: true })} />
    <Route path="/explorer/block/:hash" element={page(() => import("./app/explorer/block/[hash]/page"), { async: true })} />
    <Route path="/explorer/block-height/:height" element={page(() => import("./app/explorer/block-height/[height]/page"), { async: true })} />
    <Route path="/explorer/ethereum/address/:address" element={page(() => import("./app/explorer/ethereum/address/[address]/page"), { async: true })} />
    <Route path="/explorer/ethereum/tx/:hash" element={page(() => import("./app/explorer/ethereum/tx/[hash]/page"), { async: true })} />
    <Route path="/explorer/learn/:lesson" element={page(() => import("./app/explorer/learn/[lesson]/page"), { async: true })} />
    <Route path="/explorer/search/:value" element={page(() => import("./app/explorer/search/[value]/page"), { async: true })} />
    <Route path="/explorer/tron/address/:address" element={page(() => import("./app/explorer/tron/address/[address]/page"), { async: true })} />
    <Route path="/explorer/tron/tx/:txid" element={page(() => import("./app/explorer/tron/tx/[txid]/page"), { async: true })} />
    <Route path="/explorer/tx/:hash" element={page(() => import("./app/explorer/tx/[hash]/page"), { async: true })} />
    <Route path="/faq" element={page(() => import("./app/faq/page"))} />
    <Route path="/gift-cards" element={page(() => import("./app/gift-cards/page"))} />
    <Route path="/help-center" element={page(() => import("./app/help-center/page"))} />
    <Route path="/learn" element={page(() => import("./app/learn/page"))} />
    <Route path="/login" element={page(() => import("./app/login/page"))} />
    <Route path="/privacy-policy" element={page(() => import("./app/privacy-policy/page"))} />
    <Route path="/school" element={page(() => import("./app/school/page"))} />
    <Route path="/school/certificate/:id" element={page(() => import("./app/school/certificate/[id]/page"), { async: true })} />
    <Route path="/school/courses" element={page(() => import("./app/school/courses/page"))} />
    <Route path="/school/courses/:slug" element={page(() => import("./app/school/courses/[slug]/page"), { async: true })} />
    <Route path="/school/courses/:slug/learn" element={page(() => import("./app/school/courses/[slug]/learn/page"), { async: true })} />
    <Route path="/school/my-learning" element={page(() => import("./app/school/my-learning/page"))} />
    <Route path="/security" element={page(() => import("./app/security/page"))} />
    <Route path="/story" element={page(() => import("./app/story/page"))} />
    <Route path="/terms-of-use" element={page(() => import("./app/terms-of-use/page"))} />
    <Route path="*" element={<NotFoundPage />} />
  </Route>
);
